export default __webpack_public_path__ + "static/media/charles.0b617d8d.jpg";